<div class="flex flex-col threshold-dialog">
  <div class="padding">
    <div class="flex justify-end">
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="dialogRef.close()"></mat-icon>
    </div>
    <div class="flex flex-col items-center">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
      <div class="title">{{data?.title}}</div>
      <div class="description">{{data?.description}}</div>
      <div class="info-grid">
        <span class="info-label">{{'THRESHOLD_DIALOG.COMPONENT_NAME' | transloco}}</span>
        <span class="info-separator">:</span>
        <span class="info-value" [matTooltip]="data?.componentName" matTooltipPosition="above">{{ data?.componentName ? data?.componentName : '-' }}</span>
        <span class="info-label">{{'THRESHOLD_DIALOG.ESTIMATED_TIME' | transloco}}</span>
        <span class="info-separator">:</span>
        <span class="info-value">{{ estimatedTime ? estimatedTime : '-' }}</span>
        <span class="info-label">{{'THRESHOLD_DIALOG.ELAPSED_TIME' | transloco}}</span>
        <span class="info-separator">:</span>
        <span class="info-value">{{ elapsedTime ? elapsedTime: '-' }}</span>
      </div>
    </div>
  </div>
  <mat-divider class="w-100-percent full-width-divider"></mat-divider>
  <div class="flex dialog-actions padding">
    <button class="cancel-btn" (click)="dialogRef.close()">{{ 'BUTTONS.CANCEL'| transloco }}</button>
    <button class="abort-btn" (click)="onAbort()" [ngClass]="{'disabled': data?.disableAbort}">{{ 'BUTTONS.ABORT'| transloco }}</button>
  </div>
</div>